import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Button,
  Container,
  Content,
  Header,
  Loader,
  SelectPicker,
  CheckPicker,
  Checkbox,
  Radio,
  InputGroup,
} from "rsuite";
import { Form, Field, FormSpy } from "react-final-form";
import { SongServices } from "../../../core/services/SongServices";
import { HelperServices } from "../../../core/services/HelperServices";
import "./Song.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { get, debounce, uniq, findIndex, findKey } from "lodash/fp";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { useSelector } from "react-redux";
import CustomSelector from "../../shared/customSelector";
import { useTranslation } from "react-i18next";
import useDecryptedParams from "../../../navigation/useDecryptParams";
import { encryptUrl } from "../../../navigation/useDecryptParams";
import { SongFields } from "./SongDataTypes";
import { useDispatch } from "react-redux";
import { setActionData } from "../../../redux/userActionData";
import CloseIcon from "@rsuite/icons/Close";
import SearchIcon from "@rsuite/icons/Search";
import {
  messageTypeArr,
  appConstObj,
  singerCombObjArr,
  mediaTypeObjArr,
  mediaSourceObjArr,
  songTypeObjArr,
} from "../../../core/config/AppConstants";
import { ValidatorCustom } from "../../validators/ValidatorCustom";
import { ContentRoutes } from "../../../navigation/NavConstant";
import { addLabelValue, isNotEmpty, isNotNull } from "../../../utils/helpers";
import SingersModal from "../Singers/SingersModal";
import ActorsModal from "../Actors/ActorsModal";
import ComposersModal from "../Composers/ComposersModal";
import LyricistsModal from "../Lyricists/LyricistsModal";
import MediaFileUpload from "../../components/Elements/MediaFileUpload";
import ImageUpload from "../../components/Elements/ImageUpload";
function Song() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loader, setLoading] = useState(true);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [songFetched, setSongFetched] = useState(false);
  const [langList, setLangList] = useState([]);
  const [moodList, setMoodList] = useState([]);
  const [labelList, setLabelList] = useState([]);
  const [genreList, setGenreList] = useState([]);
  const [subGenreList, setSubGenreList] = useState([]);
  const [licenseList, setLicenseList] = useState([]);
  const [tempoList, setTempoList] = useState([]);
  const [eraList, setEraList] = useState([]);
  const [festiveList, setFestiveList] = useState([]);
  const [ratingChartList, setRatingChartList] = useState([]);

  const dispatch = useDispatch();
  const params: any = useParams();
  const [songImageFile, setSongImageFile] = useState<any>();
  const [songImage, setSongImage] = useState("");
  const [songPlayUrl, setSongPlayUrl] = useState<string>();
  const [songFile, setSongFile] = useState<any>(null);
  const [duration, setDuration] = useState<number>(0);

  const [songData, setSongData] = useState<SongFields>({});

  const [subGenreFetched, setSubGenreFetched] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [openModalByName, setOpenModalByName] = useState("");
  let [decryptedParams] = useDecryptedParams(params);

  const ecryptedSongId = encryptUrl(`${decryptedParams.id}`);

  const [formData, setFormData] = useState<any>({
    name: "",
    file_name: null,
    media_image: null,
    language_id: null,
    mood_ids: "",
    singer1_id: null,
    singer1_name: "",
    singer2_id: null,
    singer2_name: "",
    singer3_id: null,
    singer3_name: "",
    singer4_id: null,
    singer4_name: "",
    singer_combination: "",
    actor1_id: null,
    actor1_name: "",
    actor2_id: null,
    actor2_name: "",
    actor3_id: null,
    actor3_name: "",
    lyricist_id: null,
    lyricist: "",
    composer_id: null,
    composer: "",
    label_id: null,
    genre_id: null,
    sub_genre_id: null,
    license_id: null,
    song_type: "",
    media_type: "audio",
    sourced_from: "form",
    tempo_id: null,
    era_id: null,
    album_name: "",
    festives_seasons_id: "",
    release_year: "",
    rating_chart_id: null,
    status: 1,
  });

  const searchSelectEntity = (e: any, entity_name: string) => {
    if (e.key === "Enter" || e.type === "click") {
      setOpenModalByName(entity_name);
    }
  };
  async function getLangList(params: any) {
    try {
      setLoading(true);
      const res = await HelperServices.getAllValidLanguages(params);
      setLangList(get("data.data", res));
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  async function getTempoList(params: any) {
    try {
      setLoading(true);
      const res = await HelperServices.getAllValidTempos(params);
      setTempoList(get("data.data", res));
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  async function getFestiveList(params: any) {
    try {
      setLoading(true);
      const res = await HelperServices.getAllValidFestiveSeasons(params);
      const festTypesArr = addLabelValue(
        get("data.data", res),
        "festive_name",
        "id"
      );
      setFestiveList(festTypesArr);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  async function getRatingChartList(params: any) {
    try {
      setLoading(true);
      const res = await HelperServices.getAllValidRatingCharts(params);
      setRatingChartList(get("data.data", res));
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  async function getEraList(params: any) {
    try {
      setLoading(true);
      const res = await HelperServices.getAllValidEras(params);
      setEraList(get("data.data", res));
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  async function getLicenseList(params: any) {
    try {
      setLoading(true);
      const res = await HelperServices.getAllValidLicenses(params);
      setLicenseList(get("data.data", res));
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  async function getGenreList(params: any) {
    try {
      setLoading(true);
      const res = await HelperServices.getAllValidGenres(params);
      setGenreList(get("data.data", res));
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  async function getLabelList(params: any) {
    try {
      setLoading(true);
      const res = await HelperServices.getAllValidLabels(params);
      setLabelList(get("data.data", res));
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  async function getMoodList(params: any) {
    try {
      setLoading(true);
      const res = await HelperServices.getAllValidMoods(params);
      const moodTypesArr = addLabelValue(
        get("data.data", res),
        "mood_name",
        "id"
      );
      setMoodList(moodTypesArr);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  async function handleGenreChange(genreId: number) {
    try {
      setSubGenreFetched(false);
      const res = await HelperServices.getAllValidGenres({
        parent_genre: genreId,
      });
      setSubGenreList(res.data.data);
      setSubGenreFetched(true);
    } catch (error) {
      console.log(error);
    }
  }

  async function init() {
    try {
      if (decryptedParams.id) {
        setSongFetched(false);
        const response: any = await SongServices.viewSong(+decryptedParams.id);
        const sngData: any = response?.data?.data;
        const keyMapper: any = { name: "title" };
        setSongData(sngData);
        let obj = { ...formData };
        //review comment: response?.data?.data? should be in a single variable and then used further upon;
        if (sngData?.media_image_url) {
          setSongImage(sngData?.media_image_url);
        }
        if (sngData?.media_file_url) {
          setSongPlayUrl(sngData?.media_file_url);
        }
        let keyMapperIndex = Object.keys(keyMapper);
        Object.keys(obj).map((formKey) => {
          if (keyMapperIndex.includes(formKey)) {
            obj[formKey] = sngData[keyMapper[formKey]];
          } else {
            obj[formKey] = sngData[formKey];
          }
        });
        setFormData({ ...obj });

        setLoading(false);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setSongFetched(true); // Mark component as ready to render
    }
  }

  useEffect(() => {
    init();
  }, [decryptedParams.id]);

  useEffect(() => {
    getLangList({});
    getMoodList({});
    getLabelList({});
    getGenreList({});
    getLicenseList({});
    getTempoList({});
    getEraList({});
    getFestiveList({});
    getRatingChartList({});
  }, []);

  async function saveSong(form: any, songId?: any) {
    try {
      setLoading(true);
      setSubmitLoader(true);
      let response: any;
      if (songId) {
        response = await SongServices.updateSong(+songId, form);
      } else {
        response = await SongServices.createSong(form);
      }
      setSongData(response?.data?.data);
      setLoading(false);
      UtilityServices.showToaster({
        message: response?.data?.message,
      });
      navigate(ContentRoutes.SONGS);
    } catch (error: any) {
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
      setErrorMessage(error?.message);
    } finally {
      setLoading(false);
      setSubmitLoader(false);
    }
  }

  const onSubmit = (val: any) => {
    if (submitLoader) {
      return;
    }

    const form = new FormData();
    const fileFieldNames = [
      "file_name",
      "media_image",
      "song_file",
      "image",
      "_song_file",
      "_image",
    ];
    for (var key in val) {
      if (isNotNull(val[key]) && !fileFieldNames.includes(key))
        form.append(key, val[key]);
    }
    if (songImageFile instanceof File && songImageFile.size > 0) {
      form.append("media_image", songImageFile, songImageFile.name);
    }
    if (songFile instanceof File && songFile.size > 0) {
      form.append("file_name", songFile, songFile.name);
    }
    if (decryptedParams.id) {
      saveSong(form, decryptedParams.id);
    } else {
      saveSong(form);
    }
  };

  function onSelectSinger1(singerData: any) {
    setOpenModalByName("");
    setFormData({
      ...formData,
      ...{ singer1_name: singerData?.artist_name, singer1_id: singerData?.id },
    });
  }

  function onSelectSinger2(singerData: any) {
    setOpenModalByName("");
    setFormData({
      ...formData,
      ...{ singer2_name: singerData?.artist_name, singer2_id: singerData?.id },
    });
  }

  function onSelectSinger3(singerData: any) {
    setOpenModalByName("");
    setFormData({
      ...formData,
      ...{ singer3_name: singerData?.artist_name, singer3_id: singerData?.id },
    });
  }

  function onSelectSinger4(singerData: any) {
    setOpenModalByName("");
    setFormData({
      ...formData,
      ...{ singer4_name: singerData?.artist_name, singer4_id: singerData?.id },
    });
  }

  function onSelectActor1(actorData: any) {
    setOpenModalByName("");
    setFormData({
      ...formData,
      ...{ actor1_name: actorData?.actor_name, actor1_id: actorData?.id },
    });
  }

  function onSelectActor2(actorData: any) {
    setOpenModalByName("");
    setFormData({
      ...formData,
      ...{ actor2_name: actorData?.actor_name, actor2_id: actorData?.id },
    });
  }

  function onSelectActor3(actorData: any) {
    setOpenModalByName("");
    setFormData({
      ...formData,
      ...{ actor3_name: actorData?.actor_name, actor3_id: actorData?.id },
    });
  }

  function onSelectLyricist(lyrData: any) {
    setOpenModalByName("");
    setFormData({
      ...formData,
      ...{ lyricist: lyrData?.lyricist_name, lyricist_id: lyrData?.id },
    });
  }

  function onSelectComposer(compData: any) {
    setOpenModalByName("");
    setFormData({
      ...formData,
      ...{ composer: compData?.composer_name, composer_id: compData?.id },
    });
  }

  const handleFormValuesChange = (values) => {
    setFormData(values); // Update formData state with current form values
  };

  return (
    <div className="song">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          content={t("LOADING")}
          center
          backdrop={true}
        />
      )}
      <Container className="container">
        <Header className="header">
          <h4 className="mb-3 song-page-title">
            {decryptedParams.id ? t("UPDATE") : t("CREATE")} {t("SONG")}
          </h4>
        </Header>
        <Content className="content song-create-wrap">
          <Form
            onSubmit={onSubmit}
            validate={(values: any) => {
              const errors: any = {};
              if (!values.name) {
                errors.name = t("REQUIRED", {
                  field:
                    t("SONG").toLowerCase() + " " + t("NAME").toLowerCase(),
                });
              }
              if (!(songFile instanceof File) && !decryptedParams.id) {
                errors.song_file = t("REQUIRED_SELECT", {
                  field:
                    t("SONG").toLowerCase() + " " + t("FILE").toLowerCase(),
                });
              }
              if (!values.language_id) {
                errors.language_id = t("REQUIRED_SELECT", {
                  field: t("LANGUAGE").toLowerCase(),
                });
              }
              if (!values.license_id) {
                errors.license_id = t("REQUIRED_SELECT", {
                  field: t("LICENSE").toLowerCase(),
                });
              }
              if (!values.song_type) {
                errors.song_type = t("REQUIRED_SELECT", {
                  field:
                    t("SONG").toLowerCase() + " " + t("TYPE").toLowerCase(),
                });
              }
              if (!values.genre_id) {
                errors.genre_id = t("REQUIRED_SELECT", {
                  field: t("GENRE").toLowerCase(),
                });
              }
              if (!values.label_id) {
                errors.label_id = t("REQUIRED_SELECT", {
                  field: t("LABEL").toLowerCase(),
                });
              }
              if (!values.singer1_id) {
                errors.singer1_name = t("REQUIRED_SELECT", {
                  field: t("SINGER1").toLowerCase(),
                });
              }
              if (!values.media_type) {
                errors.media_type = t("REQUIRED_SELECT", {
                  field:
                    t("MEDIA").toLowerCase() + " " + t("TYPE").toLowerCase(),
                });
              }

              return errors;
            }}
            initialValues={{ ...formData }}
            render={({ handleSubmit, form, errors, submitFailed, values }) => (
              <form onSubmit={handleSubmit} className="song-form-shell">
                {songFetched && (
                  <div className="song-upload-grid">
                    <div className="song-upload-card">
                      <div className="song-section-subtitle">Media File</div>
                      <MediaFileUpload
                        name="_song_file"
                        accept="audio/*,video/mp4"
                        label="UPLOAD MEDIA FILE"
                        mediaFile={songFile}
                        setMediaFile={setSongFile}
                        mediaUrl={songPlayUrl}
                        mediaType={values?.media_type}
                        mediaImageUrl={songImage}
                        onMediaTypeChange={(selectedMediaType: string) => {
                          form.change("media_type", selectedMediaType);
                        }}
                        errorMessage={submitFailed ? errors?.song_file : ""}
                      />
                    </div>
                    <div className="song-upload-card">
                      <div className="song-section-subtitle">Cover Image</div>
                      <ImageUpload
                        name="_image"
                        entityImage={songImage}
                        setEntityImageFile={(v: File) => {
                          if (v && v.size) {
                            setSongImageFile(v);
                            setSongImage(URL.createObjectURL(v));
                          } else {
                            setSongImageFile(null);
                            setSongImage(null);
                          }
                        }}
                      />
                    </div>
                  </div>
                )}
                <div className="form-part song-form-card">
                  <div className="song-section-heading">Primary Details</div>
                  <div className="flex-container">
                    <Field
                      name="name"
                      validate={
                        ValidatorCustom.isAlphaNumericDashSpacePatternValidator
                      }
                    >
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>
                            {t("SONG")} {t("TITLE")}*
                          </label>
                          <input {...input} type="text" />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="language_id">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <CustomSelector
                            loaderMsg={t("FETCHING_DATA_OF", {
                              field: t("LANGUAGE").toLocaleLowerCase(),
                            })}
                            isRequired={true}
                            valueKey="id"
                            labelKey="lang_name"
                            isDisable={!langList?.length ? true : false}
                            labelName={t("LANGUAGE")}
                            defaultValue={input.value}
                            onClear={(event: any) => {
                              form.change("language_id", null);
                            }}
                            listData={langList?.length ? langList : []}
                            onSelect={(e: any, selectedObj: any) => {
                              form.change("language_id", e);
                            }}
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="license_id">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <CustomSelector
                            loaderMsg={t("FETCHING_DATA_OF", {
                              field: t("LICENSE").toLocaleLowerCase(),
                            })}
                            isRequired={true}
                            valueKey="id"
                            labelKey="license_name"
                            isDisable={!licenseList?.length ? true : false}
                            labelName={t("LICENSE")}
                            defaultValue={input.value}
                            onClear={(event: any) => {
                              form.change("license_id", null);
                            }}
                            listData={licenseList?.length ? licenseList : []}
                            onSelect={(e: any, selectedObj: any) => {
                              form.change("license_id", e);
                            }}
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                  </div>

                  <div className="flex-container">
                    <Field name="song_type">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <CustomSelector
                            loaderMsg={t("FETCHING_DATA_OF", {
                              field:
                                t("SONG").toLocaleLowerCase() +
                                " " +
                                t("TYPE").toLocaleLowerCase(),
                            })}
                            isRequired={true}
                            valueKey="value"
                            labelKey="label"
                            isDisable={!songTypeObjArr?.length ? true : false}
                            labelName={t("SONG") + " " + t("TYPE")}
                            defaultValue={input.value}
                            onClear={(event: any) => {
                              form.change("song_type", "");
                            }}
                            listData={
                              songTypeObjArr?.length ? songTypeObjArr : []
                            }
                            onSelect={(e: any, selectedObj: any) => {
                              form.change("song_type", e);
                            }}
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="genre_id">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <CustomSelector
                            loaderMsg={t("FETCHING_DATA_OF", {
                              field: t("GENRE").toLocaleLowerCase(),
                            })}
                            isRequired={true}
                            valueKey="id"
                            labelKey="genre_name"
                            isDisable={!genreList?.length ? true : false}
                            labelName={t("GENRE")}
                            defaultValue={input.value}
                            onClear={(event: any) => {
                              form.change("genre_id", null);
                              form.change("sub_genre_id", null);
                              setSubGenreList([]);
                            }}
                            listData={genreList?.length ? genreList : []}
                            onSelect={(e: any, selectedObj: any) => {
                              form.change("genre_id", e);
                              handleGenreChange(e);
                            }}
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="sub_genre_id">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <CustomSelector
                            loaderMsg={
                              form.getState().values.genre_id &&
                              !subGenreList?.length &&
                              !subGenreFetched
                                ? t("FETCHING_DATA_OF", {
                                    field: t("SUB_GENRE").toLocaleLowerCase(),
                                  })
                                : null
                            }
                            isRequired={false}
                            valueKey="id"
                            labelKey="genre_name"
                            isDisable={false}
                            labelName={t("SUB_GENRE")}
                            defaultValue={input.value}
                            onClear={(event: any) => {
                              form.change("sub_genre_id", null);
                            }}
                            listData={subGenreList?.length ? subGenreList : []}
                            onSelect={(e: any, selectedObj: any) => {
                              form.change("sub_genre_id", e);
                            }}
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="label_id">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <CustomSelector
                            loaderMsg={t("FETCHING_DATA_OF", {
                              field: t("LABEL").toLocaleLowerCase(),
                            })}
                            isRequired={true}
                            valueKey="id"
                            labelKey="label_name"
                            isDisable={!labelList?.length ? true : false}
                            labelName={t("LABEL")}
                            defaultValue={input.value}
                            onClear={(event: any) => {
                              form.change("label_id", null);
                            }}
                            listData={labelList?.length ? labelList : []}
                            onSelect={(e: any, selectedObj: any) => {
                              form.change("label_id", e);
                            }}
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="singer_combination">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <CustomSelector
                            loaderMsg={t("FETCHING_DATA_OF", {
                              field:
                                t("SINGER").toLocaleLowerCase() +
                                " " +
                                t("COMBINATION").toLocaleLowerCase(),
                            })}
                            isRequired={false}
                            valueKey="value"
                            labelKey="label"
                            labelName={t("SINGER") + " " + t("COMBINATION")}
                            defaultValue={input.value}
                            onClear={(event: any) => {
                              form.change("singer_combination", "");
                            }}
                            listData={
                              singerCombObjArr?.length ? singerCombObjArr : []
                            }
                            onSelect={(e: any, selectedObj: any) => {
                              form.change("singer_combination", e);
                            }}
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <div className="flex-item"></div>
                  </div>
                  <div className="flex-container">
                    <Field name="singer1_name">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label
                            onClick={(e: any) =>
                              searchSelectEntity(e, "select-singer1")
                            }
                          >
                            {t("SELECT") + " " + t("SINGER1")}*
                          </label>
                          <InputGroup>
                            <input
                              {...input}
                              type="text"
                              autoComplete="off"
                              disabled={true}
                              onClick={(e: any) =>
                                searchSelectEntity(e, "select-singer1")
                              }
                            />
                            <InputGroup.Button
                              title={t("SEARCH")}
                              onClick={(e: any) =>
                                searchSelectEntity(e, "select-singer1")
                              }
                            >
                              <SearchIcon />
                            </InputGroup.Button>
                            <InputGroup.Button
                              title={t("CLEAR")}
                              onClick={() => {
                                form.change("singer1_id", null);
                                form.change("singer1_name", "");
                              }}
                            >
                              <CloseIcon />
                            </InputGroup.Button>
                          </InputGroup>
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="singer2_name">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label
                            onClick={(e: any) =>
                              searchSelectEntity(e, "select-singer2")
                            }
                          >
                            {t("SELECT") + " " + t("SINGER2")}
                          </label>
                          <InputGroup>
                            <input
                              {...input}
                              type="text"
                              disabled={true}
                              autoComplete="off"
                              onClick={(e: any) =>
                                searchSelectEntity(e, "select-singer2")
                              }
                            />
                            <InputGroup.Button
                              title={t("SEARCH")}
                              onClick={(e: any) =>
                                searchSelectEntity(e, "select-singer2")
                              }
                            >
                              <SearchIcon />
                            </InputGroup.Button>
                            <InputGroup.Button
                              title={t("CLEAR")}
                              onClick={() => {
                                form.change("singer2_id", null);
                                form.change("singer2_name", "");
                              }}
                            >
                              <CloseIcon />
                            </InputGroup.Button>
                          </InputGroup>
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="singer3_name">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label
                            onClick={(e: any) =>
                              searchSelectEntity(e, "select-singer3")
                            }
                          >
                            {t("SELECT") + " " + t("SINGER3")}
                          </label>
                          <InputGroup>
                            <input
                              {...input}
                              type="text"
                              autoComplete="off"
                              disabled={true}
                              onClick={(e: any) =>
                                searchSelectEntity(e, "select-singer3")
                              }
                            />
                            <InputGroup.Button
                              title={t("SEARCH")}
                              onClick={(e: any) =>
                                searchSelectEntity(e, "select-singer3")
                              }
                            >
                              <SearchIcon />
                            </InputGroup.Button>
                            <InputGroup.Button
                              title={t("CLEAR")}
                              onClick={() => {
                                form.change("singer3_id", null);
                                form.change("singer3_name", "");
                              }}
                            >
                              <CloseIcon />
                            </InputGroup.Button>
                          </InputGroup>
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="singer4_name">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label
                            onClick={(e: any) =>
                              searchSelectEntity(e, "select-singer4")
                            }
                          >
                            {t("SELECT") + " " + t("SINGER4")}
                          </label>
                          <InputGroup>
                            <input
                              {...input}
                              type="text"
                              autoComplete="off"
                              disabled={true}
                              onClick={(e: any) =>
                                searchSelectEntity(e, "select-singer4")
                              }
                            />
                            <InputGroup.Button
                              title={t("SEARCH")}
                              onClick={(e: any) =>
                                searchSelectEntity(e, "select-singer4")
                              }
                            >
                              <SearchIcon />
                            </InputGroup.Button>
                            <InputGroup.Button
                              title={t("CLEAR")}
                              onClick={() => {
                                form.change("singer4_id", null);
                                form.change("singer4_name", "");
                              }}
                            >
                              <CloseIcon />
                            </InputGroup.Button>
                          </InputGroup>
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <div className="flex-item"></div>
                  </div>
                  <div className="flex-container">
                    <Field name="composer">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label
                            onClick={(e: any) =>
                              searchSelectEntity(e, "select-composer")
                            }
                          >
                            {t("SELECT") + " " + t("COMPOSER")}
                          </label>
                          <InputGroup>
                            <input
                              {...input}
                              type="text"
                              autoComplete="off"
                              disabled={true}
                              onClick={(e: any) =>
                                searchSelectEntity(e, "select-composer")
                              }
                            />
                            <InputGroup.Button
                              title={t("SEARCH")}
                              onClick={(e: any) =>
                                searchSelectEntity(e, "select-composer")
                              }
                            >
                              <SearchIcon />
                            </InputGroup.Button>
                            <InputGroup.Button
                              title={t("CLEAR")}
                              onClick={() => {
                                form.change("composer_id", null);
                                form.change("composer", "");
                              }}
                            >
                              <CloseIcon />
                            </InputGroup.Button>
                          </InputGroup>
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="lyricist">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label
                            onClick={(e: any) =>
                              searchSelectEntity(e, "select-lyricist")
                            }
                          >
                            {t("SELECT") + " " + t("LYRICIST")}
                          </label>
                          <InputGroup>
                            <input
                              {...input}
                              type="text"
                              autoComplete="off"
                              disabled={true}
                              onClick={(e: any) =>
                                searchSelectEntity(e, "select-lyricist")
                              }
                            />
                            <InputGroup.Button
                              title={t("SEARCH")}
                              onClick={(e: any) =>
                                searchSelectEntity(e, "select-lyricist")
                              }
                            >
                              <SearchIcon />
                            </InputGroup.Button>
                            <InputGroup.Button
                              title={t("CLEAR")}
                              onClick={() => {
                                form.change("lyricist_id", null);
                                form.change("lyricist", "");
                              }}
                            >
                              <CloseIcon />
                            </InputGroup.Button>
                          </InputGroup>
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="album_name">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>
                            {t("ALBUM")} / {t("MOVIE")}
                          </label>
                          <input {...input} type="text" autoComplete="off" />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                  </div>
                  <div className="flex-container">
                    <Field name="actor1_name">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label
                            onClick={(e: any) =>
                              searchSelectEntity(e, "select-actor1")
                            }
                          >
                            {t("SELECT") + " " + t("ACTOR1")}
                          </label>
                          <InputGroup>
                            <input
                              {...input}
                              type="text"
                              autoComplete="off"
                              disabled={true}
                              onClick={(e: any) =>
                                searchSelectEntity(e, "select-actor1")
                              }
                            />
                            <InputGroup.Button
                              title={t("SEARCH")}
                              onClick={(e: any) =>
                                searchSelectEntity(e, "select-actor1")
                              }
                            >
                              <SearchIcon />
                            </InputGroup.Button>
                            <InputGroup.Button
                              title={t("CLEAR")}
                              onClick={() => {
                                form.change("actor1_id", null);
                                form.change("actor1_name", "");
                              }}
                            >
                              <CloseIcon />
                            </InputGroup.Button>
                          </InputGroup>
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="actor2_name">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label
                            onClick={(e: any) =>
                              searchSelectEntity(e, "select-actor2")
                            }
                          >
                            {t("SELECT") + " " + t("ACTOR2")}
                          </label>
                          <InputGroup>
                            <input
                              {...input}
                              type="text"
                              autoComplete="off"
                              disabled={true}
                              onClick={(e: any) =>
                                searchSelectEntity(e, "select-actor2")
                              }
                            />
                            <InputGroup.Button
                              title={t("SEARCH")}
                              onClick={(e: any) =>
                                searchSelectEntity(e, "select-actor2")
                              }
                            >
                              <SearchIcon />
                            </InputGroup.Button>
                            <InputGroup.Button
                              title={t("CLEAR")}
                              onClick={() => {
                                form.change("actor2_id", null);
                                form.change("actor2_name", "");
                              }}
                            >
                              <CloseIcon />
                            </InputGroup.Button>
                          </InputGroup>
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="actor3_name">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label
                            onClick={(e: any) =>
                              searchSelectEntity(e, "select-actor3")
                            }
                          >
                            {t("SELECT") + " " + t("ACTOR3")}
                          </label>
                          <InputGroup>
                            <input
                              {...input}
                              type="text"
                              autoComplete="off"
                              disabled={true}
                              onClick={(e: any) =>
                                searchSelectEntity(e, "select-actor3")
                              }
                            />
                            <InputGroup.Button
                              title={t("SEARCH")}
                              onClick={(e: any) =>
                                searchSelectEntity(e, "select-actor3")
                              }
                            >
                              <SearchIcon />
                            </InputGroup.Button>
                            <InputGroup.Button
                              title={t("CLEAR")}
                              onClick={() => {
                                form.change("actor3_id", null);
                                form.change("actor3_name", "");
                              }}
                            >
                              <CloseIcon />
                            </InputGroup.Button>
                          </InputGroup>
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                  </div>
                  <div className="flex-container">
                    <Field name="release_year">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>
                            {t("RELEASE")} {t("YEAR")}
                          </label>
                          <input
                            {...input}
                            type="number"
                            autoComplete="off"
                            min="1900"
                            max="2099"
                            onInput={(e) => {
                              const target = e.target as HTMLInputElement;
                              if (target.value.length > 4)
                                target.value = target.value.slice(0, 4);
                            }}
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="media_type">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <CustomSelector
                            loaderMsg={t("FETCHING_DATA_OF", {
                              field:
                                t("MEDIA").toLocaleLowerCase() +
                                " " +
                                t("TYPE").toLocaleLowerCase(),
                            })}
                            isRequired={true}
                            valueKey="value"
                            labelKey="label"
                            isDisable={!mediaTypeObjArr?.length ? true : false}
                            labelName={t("MEDIA") + " " + t("TYPE")}
                            defaultValue={input.value}
                            onClear={(event: any) => {
                              form.change("media_type", null);
                            }}
                            listData={
                              mediaTypeObjArr?.length ? mediaTypeObjArr : []
                            }
                            onSelect={(e: any, selectedObj: any) => {
                              form.change("media_type", e);
                            }}
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="status">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label className="block">{t("STATUS")}*</label>
                          <Radio
                            onChangeCapture={(e: any) => {
                              if (e.target.checked) {
                                form.change("status", 1);
                              }
                            }}
                            checked={input.value === 1 ? true : false}
                            name="status"
                            value="1"
                          >
                            {t("ACTIVE")}
                          </Radio>
                          <Radio
                            onChangeCapture={(e: any) => {
                              if (e.target.checked) {
                                form.change("status", 0);
                              }
                            }}
                            checked={input.value === 0 ? true : false}
                            name="status"
                            value="0"
                          >
                            {t("INACTIVE")}
                          </Radio>
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                  </div>
                </div>
                <div className="address-bx song-section-banner">
                  <h5>{t("ADDITIONAL") + " " + t("INFO")}</h5>
                </div>
                <div className="form-part song-form-card">
                  <div className="flex-container">
                    <Field name="mood_ids">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>{t("MOOD")}</label>
                          <CheckPicker
                            sticky
                            onChange={(e: any) => {
                              let mTypes = e.filter(isNotEmpty);
                              if (e.length) {
                                form.change("mood_ids", mTypes.toString());
                              } else {
                                form.change("mood_ids", "");
                              }
                            }}
                            onClean={() => {
                              form.change("mood_ids", "");
                            }}
                            data={moodList}
                            value={input?.value?.toString().split(",")}
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="festives_seasons_id">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>{t("FESTIVE")}</label>
                          <CheckPicker
                            sticky
                            onChange={(e: any) => {
                              let festTypes = e.filter(isNotEmpty);
                              if (e.length) {
                                form.change(
                                  "festives_seasons_id",
                                  festTypes.toString()
                                );
                              } else {
                                form.change("festives_seasons_id", "");
                              }
                            }}
                            onClean={() => {
                              form.change("festives_seasons_id", "");
                            }}
                            data={festiveList}
                            value={input?.value?.toString().split(",")}
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="tempo_id">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <CustomSelector
                            loaderMsg={t("FETCHING_DATA_OF", {
                              field: t("TEMPO").toLocaleLowerCase(),
                            })}
                            isRequired={false}
                            valueKey="id"
                            labelKey="tempo_name"
                            isDisable={!tempoList?.length ? true : false}
                            labelName={t("TEMPO")}
                            defaultValue={input.value}
                            onClear={(event: any) => {
                              form.change("tempo_id", null);
                            }}
                            listData={tempoList?.length ? tempoList : []}
                            onSelect={(e: any, selectedObj: any) => {
                              form.change("tempo_id", e);
                            }}
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                  </div>
                  <div className="flex-container">
                    <Field name="era_id">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <CustomSelector
                            loaderMsg={t("FETCHING_DATA_OF", {
                              field: t("ERA").toLocaleLowerCase(),
                            })}
                            isRequired={false}
                            valueKey="id"
                            labelKey="era_name"
                            isDisable={!tempoList?.length ? true : false}
                            labelName={t("ERA")}
                            defaultValue={input.value}
                            onClear={(event: any) => {
                              form.change("era_id", null);
                            }}
                            listData={eraList?.length ? eraList : []}
                            onSelect={(e: any, selectedObj: any) => {
                              form.change("era_id", e);
                            }}
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="rating_chart_id">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <CustomSelector
                            loaderMsg={t("FETCHING_DATA_OF", {
                              field:
                                t("RATING").toLocaleLowerCase() +
                                " " +
                                t("CHART").toLocaleLowerCase(),
                            })}
                            isRequired={false}
                            valueKey="id"
                            labelKey="rating_chart_title"
                            isDisable={!ratingChartList?.length ? true : false}
                            labelName={t("RATING") + " " + t("CHART")}
                            defaultValue={input.value}
                            onClear={(event: any) => {
                              form.change("rating_chart_id", null);
                            }}
                            listData={
                              ratingChartList?.length ? ratingChartList : []
                            }
                            onSelect={(e: any, selectedObj: any) => {
                              form.change("rating_chart_id", e);
                            }}
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="sourced_from">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <CustomSelector
                            loaderMsg={t("FETCHING_DATA_OF", {
                              field:
                                t("SOURCED").toLocaleLowerCase() +
                                " " +
                                t("FROM").toLocaleLowerCase(),
                            })}
                            isRequired={false}
                            valueKey="value"
                            labelKey="label"
                            isDisable={
                              !mediaSourceObjArr?.length ? true : false
                            }
                            labelName={t("SOURCED") + " " + t("FROM")}
                            defaultValue={input.value}
                            onClear={(event: any) => {
                              form.change("sourced_from", null);
                            }}
                            listData={
                              mediaSourceObjArr?.length ? mediaSourceObjArr : []
                            }
                            onSelect={(e: any, selectedObj: any) => {
                              form.change("sourced_from", e);
                            }}
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                  </div>
                </div>
                <div className="create-action d-flex flex-end song-create-actions">
                  <Link to={ContentRoutes.SONGS}>
                    <Button
                      appearance="primary"
                      color="blue"
                      type="button"
                      className="song-action-btn"
                    >
                      {t("BACK")} {t("TO").toLocaleLowerCase()}{" "}
                      {t("LIST").toLocaleLowerCase()}
                    </Button>
                  </Link>
                  <Button
                    appearance="primary"
                    color="green"
                    type="submit"
                    className="song-action-btn"
                    disabled={submitLoader}
                  >
                    {submitLoader ? (
                      <Loader size="sm" />
                    ) : decryptedParams.id ? (
                      t("UPDATE")
                    ) : (
                      t("CREATE")
                    )}
                  </Button>
                  <Button
                    appearance="default"
                    type="reset"
                    className="song-action-btn"
                    onClick={() => {
                      // review comment: move to new function
                      form.reset();
                      setSongImageFile("");
                      setSongImage("");
                      setSongPlayUrl("");
                      setSongFile("");
                      if (form.getState().values.genre_id) {
                        handleGenreChange(form.getState().values.genre_id);
                      }
                    }}
                  >
                    {t("RESET")}
                  </Button>
                </div>
                <FormSpy
                  subscription={{ values: true }}
                  onChange={({ values }) => handleFormValuesChange(values)}
                />
              </form>
            )}
          />
          {openModalByName === "select-singer1" && (
            <SingersModal
              openModal={openModalByName === "select-singer1" ? true : false}
              setOpenModal={setOpenModalByName}
              onSelectSinger={onSelectSinger1}
            />
          )}

          {openModalByName === "select-singer2" && (
            <SingersModal
              openModal={openModalByName === "select-singer2" ? true : false}
              setOpenModal={setOpenModalByName}
              onSelectSinger={onSelectSinger2}
            />
          )}

          {openModalByName === "select-singer3" && (
            <SingersModal
              openModal={openModalByName === "select-singer3" ? true : false}
              setOpenModal={setOpenModalByName}
              onSelectSinger={onSelectSinger3}
            />
          )}

          {openModalByName === "select-singer4" && (
            <SingersModal
              openModal={openModalByName === "select-singer4" ? true : false}
              setOpenModal={setOpenModalByName}
              onSelectSinger={onSelectSinger4}
            />
          )}

          {openModalByName === "select-actor1" && (
            <ActorsModal
              openModal={openModalByName === "select-actor1" ? true : false}
              setOpenModal={setOpenModalByName}
              onSelectActor={onSelectActor1}
            />
          )}

          {openModalByName === "select-actor2" && (
            <ActorsModal
              openModal={openModalByName === "select-actor2" ? true : false}
              setOpenModal={setOpenModalByName}
              onSelectActor={onSelectActor2}
            />
          )}

          {openModalByName === "select-actor3" && (
            <ActorsModal
              openModal={openModalByName === "select-actor3" ? true : false}
              setOpenModal={setOpenModalByName}
              onSelectActor={onSelectActor3}
            />
          )}

          {openModalByName === "select-composer" && (
            <ComposersModal
              openModal={openModalByName === "select-composer" ? true : false}
              setOpenModal={setOpenModalByName}
              onSelectComposer={onSelectComposer}
            />
          )}

          {openModalByName === "select-lyricist" && (
            <LyricistsModal
              openModal={openModalByName === "select-lyricist" ? true : false}
              setOpenModal={setOpenModalByName}
              onSelectLyricist={onSelectLyricist}
            />
          )}
        </Content>
      </Container>
    </div>
  );
}

export default Song;
